/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { authActions } from 'modules/common/auth/slice';
import { signInActions } from 'modules/sign-in/slice';

const idle = { loading: false, accepted: false, error: null };
export const initialState = { semantic: { ...idle }, nonSemantic: { ...idle } };

export const platformSlice = createSlice({
  name: 'feature/platform',
  initialState,
  reducers: {
    triggerSemantic(state) {
      state.semantic = { ...idle, loading: true };
    },
    triggerSemanticSucceeded(state) {
      state.semantic = { ...idle, accepted: true };
    },
    triggerSemanticFailed(state, action) {
      state.semantic = { ...idle, error: action.payload };
    },
    triggerNonSemantic(state) {
      state.nonSemantic = { ...idle, loading: true };
    },
    triggerNonSemanticSucceeded(state) {
      state.nonSemantic = { ...idle, accepted: true };
    },
    triggerNonSemanticFailed(state, action) {
      state.nonSemantic = { ...idle, error: action.payload };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(signInActions.signIn, () => initialState);
    builder.addCase(authActions.removeAuth, () => initialState);
  },
});

export const { actions: platformActions } = platformSlice;
